import { render, staticRenderFns } from "./bldtNews.vue?vue&type=template&id=36d85268&scoped=true"
import script from "./bldtNews.vue?vue&type=script&lang=js"
export * from "./bldtNews.vue?vue&type=script&lang=js"
import style0 from "./bldtNews.vue?vue&type=style&index=0&id=36d85268&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d85268",
  null
  
)

export default component.exports